import { render, staticRenderFns } from "./ConversationItem.vue?vue&type=template&id=58e4b662"
import script from "./ConversationItem.vue?vue&type=script&lang=js"
export * from "./ConversationItem.vue?vue&type=script&lang=js"
import style0 from "./ConversationItem.vue?vue&type=style&index=0&id=58e4b662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports